module.exports = __webpack_public_path__ + "static/media/ilkley-8.09d3bac6.jpg";